// Account dropdown in the header - tap to open/close below 1024px (hover handles desktop in CSS).
//
// Fix: this file is loaded with defer from sections/header.liquid. It used to be loaded `async`
// while waiting for DOMContentLoaded, and an async script can run AFTER that event has fired, in
// which case the dropdown never initialised. init() now runs immediately if the DOM is ready.

(() => {
  const isMobile = () => window.innerWidth < 1024;

  const init = () => {
    const trigger = document.querySelector('.account-trigger');
    const dropdown = document.querySelector('.account-dropdown');
    if (!trigger || !dropdown) return;

    const header = document.getElementById('header-component');
    const container = header ? header.querySelector('.header-new__container') : null;

    // The header clips overflow; while the dropdown is in use it has to be allowed to spill out.
    const setOverflow = (value) => {
      if (!header || !container) return;
      header.style.overflow = value;
      container.style.overflow = value;
    };

    trigger.addEventListener('click', (e) => {
      if (!isMobile()) return;

      setOverflow('visible');

      // Clicks on links inside the dropdown navigate normally.
      if (dropdown.contains(e.target)) return;

      e.preventDefault();
      const isExpanded = dropdown.classList.toggle('is-active');
      trigger.setAttribute('aria-expanded', String(isExpanded));
    });

    document.addEventListener('click', (e) => {
      if (!isMobile() || trigger.contains(e.target)) return;

      // Nothing to undo - skip the style writes on every unrelated tap.
      if (!dropdown.classList.contains('is-active') && !(header && header.style.overflow)) return;

      setOverflow('');
      dropdown.classList.remove('is-active');
      trigger.setAttribute('aria-expanded', 'false');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
